/**
 * GENERATED from the Floto accessibility check inventory (floto-chrome-x
 * `develop` @ 23c6a0a, Deep audit). Do not edit by hand —
 * regenerate when the extension's checks change. Three 4.1.3 titles are
 * reworded to "monitored during interaction" — they are observed while the
 * audit interacts with the page, not tested by the static scan.
 */
import type { CheckInventory } from './checks';

export const CHECK_INVENTORY: CheckInventory = {
  generatedFrom: '23c6a0a',
  totals: {
    checks: 220,
    wcagSCsCovered: 46,
  },
  wcagCoverage: {
    A: [
      '1.1.1',
      '1.2.1',
      '1.2.2',
      '1.2.3',
      '1.3.1',
      '1.3.2',
      '1.3.3',
      '1.4.1',
      '1.4.2',
      '2.1.1',
      '2.1.2',
      '2.1.4',
      '2.2.1',
      '2.2.2',
      '2.4.1',
      '2.4.2',
      '2.4.3',
      '2.4.4',
      '2.5.2',
      '2.5.3',
      '3.1.1',
      '3.2.1',
      '3.2.2',
      '3.3.1',
      '3.3.2',
      '4.1.2',
    ],
    AA: [
      '1.2.5',
      '1.3.4',
      '1.3.5',
      '1.4.3',
      '1.4.4',
      '1.4.5',
      '1.4.10',
      '1.4.11',
      '1.4.12',
      '1.4.13',
      '2.4.6',
      '2.4.7',
      '2.4.11',
      '2.5.7',
      '2.5.8',
      '3.1.2',
      '3.3.3',
      '3.3.7',
      '3.3.8',
      '4.1.3',
    ],
    AAA_suggestions: [
      '1.4.6',
      '1.4.8',
      '2.2.4',
      '2.4.9',
      '2.4.10',
      '3.1.4',
      '3.1.5',
      '3.2.5',
    ],
  },
  categories: [
    {
      id: 'color',
      name: 'Color & contrast',
      description:
        'Checks that text, icons, form fields and links are distinguishable — enough contrast, and never colour alone.',
      method: 'automated',
      checks: [
        {
          title: 'Text has enough contrast (4.5:1 / 3:1)',
          wcag: ['1.4.3'],
          level: 'AA',
        },
        {
          title: "Links in text aren't told apart by colour alone",
          wcag: ['1.4.1'],
          level: 'A',
        },
        {
          title: 'Form field edges have enough contrast (3:1)',
          wcag: ['1.4.11'],
          level: 'AA',
        },
        {
          title: 'Icons have enough contrast (3:1)',
          wcag: ['1.4.11'],
          level: 'AA',
        },
        {
          title: "Links aren't told apart from text by colour alone",
          wcag: ['1.4.1'],
          level: 'A',
        },
        {
          title: "Items aren't told apart by colour alone",
          wcag: ['1.4.1'],
          level: 'A',
        },
        {
          title: "Required fields aren't marked by colour alone",
          wcag: ['1.4.1'],
          level: 'A',
        },
      ],
    },
    {
      id: 'images',
      name: 'Images & media',
      description:
        'Checks that images, icons and media carry useful text alternatives, captions and descriptions.',
      method: 'automated',
      checks: [
        {
          title: 'Clickable image-map areas have text alternatives',
          wcag: ['2.4.4', '4.1.2'],
          level: 'A',
        },
        {
          title: 'Images have alt text',
          wcag: ['1.1.1'],
          level: 'A',
        },
        {
          title: 'Image buttons have alt text',
          wcag: ['1.1.1', '4.1.2'],
          level: 'A',
        },
        {
          title: 'Embedded objects have text alternatives',
          wcag: ['1.1.1'],
          level: 'A',
        },
        {
          title: 'Image-role elements have alt text',
          wcag: ['1.1.1'],
          level: 'A',
        },
        {
          title: 'SVG images have a text alternative',
          wcag: ['1.1.1'],
          level: 'A',
        },
        {
          title: "Alt text doesn't repeat nearby text",
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Videos have captions',
          wcag: ['1.2.2'],
          level: 'A',
        },
        {
          title: "Audio doesn't autoplay without a way to stop it",
          wcag: ['1.4.2'],
          level: 'A',
        },
        {
          title:
            'Image descriptions are actually useful (not filenames or filler)',
          wcag: ['1.1.1'],
          level: 'A',
        },
        {
          title: 'Decorative images are hidden from screen readers',
          wcag: ['1.1.1'],
          level: 'A',
        },
        {
          title: "Images hidden from screen readers don't carry a title",
          wcag: ['1.1.1'],
          level: 'A',
        },
        {
          title: 'Links that open an image have a text alternative',
          wcag: ['1.1.1'],
          level: 'A',
        },
        {
          title: 'Videos have captions and a transcript',
          wcag: ['1.2.1', '1.2.2', '1.2.3'],
          level: 'A',
        },
        {
          title: 'Audio and video have a transcript',
          wcag: ['1.2.1'],
          level: 'A',
        },
        {
          title: 'Videos have audio description where needed',
          wcag: ['1.2.3', '1.2.5'],
          level: 'A',
        },
      ],
    },
    {
      id: 'keyboard',
      name: 'Keyboard, pointer & focus',
      description:
        'Actually tabs through the page and presses controls to verify everything works by keyboard with a visible, logical focus.',
      method: 'interactive',
      checks: [
        {
          title: 'Access keys are unique',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Frames with interactive content are keyboard-reachable',
          wcag: ['2.1.1'],
          level: 'A',
        },
        {
          title: 'Scrollable areas are keyboard-accessible',
          wcag: ['2.1.1'],
          level: 'A',
        },
        {
          title: 'No server-side image maps',
          wcag: ['2.1.1'],
          level: 'A',
        },
        {
          title: 'No positive tabindex scrambling the tab order',
          wcag: ['2.4.3'],
          level: 'A',
        },
        {
          title: 'Touch targets are at least 24×24px',
          wcag: ['2.5.8'],
          level: 'AA',
        },
        {
          title: 'Keyboard focus is visible',
          wcag: ['2.4.7'],
          level: 'AA',
        },
        {
          title: 'Keyboard focus indicator is easy to see',
          wcag: ['2.4.7'],
          level: 'AA',
        },
        {
          title: 'Focus never lands on something off screen',
          wcag: ['2.4.7'],
          level: 'AA',
        },
        {
          title: 'Tab never stops on something invisible',
          wcag: ['2.4.7', '2.4.3'],
          level: 'A',
        },
        {
          title:
            "Focused element isn't hidden behind sticky headers or overlays",
          wcag: ['2.4.11'],
          level: 'AA',
        },
        {
          title: 'Tab order follows the reading order',
          wcag: ['2.4.3'],
          level: 'A',
        },
        {
          title: 'Keyboard focus never gets trapped',
          wcag: ['2.1.2'],
          level: 'A',
        },
        {
          title: "Focusing an element doesn't change the page",
          wcag: ['3.2.1'],
          level: 'A',
        },
        {
          title: "Elements don't throw keyboard focus away",
          wcag: ['2.1.1', '2.4.7', '3.2.1'],
          level: 'A',
        },
        {
          title: 'Clickable elements can be reached with the keyboard',
          wcag: ['2.1.1'],
          level: 'A',
        },
        {
          title: 'Menus open with the keyboard, not just on hover',
          wcag: ['2.1.1'],
          level: 'A',
        },
        {
          title: 'Hover-only information is also available by keyboard',
          wcag: ['2.1.1'],
          level: 'A',
        },
        {
          title: 'Buttons work with the Space key',
          wcag: ['2.1.1'],
          level: 'A',
        },
        {
          title: 'Controls work with the keyboard, not only a mouse click',
          wcag: ['2.1.1'],
          level: 'A',
        },
        {
          title: "No single-key shortcuts that can't be turned off",
          wcag: ['2.1.4'],
          level: 'A',
        },
        {
          title: 'Actions fire on release, not on press',
          wcag: ['2.5.2'],
          level: 'A',
        },
        {
          title: "Frames with links or buttons aren't skipped by Tab",
          wcag: ['2.1.1'],
          level: 'A',
        },
        {
          title: 'Drag-to-move has a non-dragging alternative',
          wcag: ['2.5.7'],
          level: 'AA',
        },
      ],
    },
    {
      id: 'sr',
      name: 'Screen reader experience',
      description:
        'Checks that every control has a name, role and state a screen reader can announce correctly.',
      method: 'automated',
      checks: [
        {
          title: "ARIA attributes are valid for the element's role",
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'ARIA roles suit the element they are on',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Braille labels have a spoken equivalent',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Custom buttons, links and menu items have a name',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'ARIA attributes are used as their role requires',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'No deprecated ARIA roles',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Dialogs have a name',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: "The page body isn't hidden from screen readers",
          wcag: ['1.3.1', '4.1.2'],
          level: 'A',
        },
        {
          title: "Content hidden from screen readers can't take keyboard focus",
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Custom input fields have a name',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Meters have a name',
          wcag: ['1.1.1'],
          level: 'A',
        },
        {
          title: 'Progress bars have a name',
          wcag: ['1.1.1'],
          level: 'A',
        },
        {
          title: 'No ARIA attributes the role forbids',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Required ARIA attributes are present',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'ARIA widgets contain the items they require',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: 'ARIA items sit inside the widget they belong to',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: 'ARIA roles are valid',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Tabs have a name',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Text-role elements contain nothing focusable',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Checkboxes, switches and radio controls have a name',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Tooltips have a name',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Tree items have a name',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'ARIA attribute values are valid',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'ARIA attribute names are valid',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Buttons have a name',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Input buttons have a name',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Links have a name',
          wcag: ['2.4.4', '4.1.2'],
          level: 'A',
        },
        {
          title: 'Frames have a title',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Frame titles are unique',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: "Interactive controls aren't nested",
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Expand/collapse summaries have a name',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'IDs used by labels and ARIA are unique',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Decorative elements are consistently hidden',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Visible label is part of the accessible name (voice control)',
          wcag: ['2.5.3'],
          level: 'A',
        },
        {
          title: 'Menus announce whether they are open',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: "Links aren't used as buttons",
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: "No names on elements that can't have one",
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Frames with the same name show the same content',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Visible label is part of the accessible name',
          wcag: ['2.5.3'],
          level: 'A',
        },
        {
          title: 'Buttons say more than a generic "Submit"',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: "Link text isn't just a symbol",
          wcag: ['2.4.4'],
          level: 'A',
        },
        {
          title: "Same link text doesn't go to different places",
          wcag: ['2.4.4'],
          level: 'A',
        },
      ],
    },
    {
      id: 'forms',
      name: 'Forms & inputs',
      description:
        'Checks that fields are labelled, grouped and error-handled so everyone can complete them.',
      method: 'automated',
      checks: [
        {
          title: 'Form fields have labels',
          wcag: ['4.1.2', '3.3.2'],
          level: 'A',
        },
        {
          title: 'Dropdowns have a name',
          wcag: ['4.1.2', '3.3.2'],
          level: 'A',
        },
        {
          title: 'Form fields have only one label',
          wcag: ['3.3.2'],
          level: 'A',
        },
        {
          title: 'Autocomplete values are valid',
          wcag: ['1.3.5'],
          level: 'AA',
        },
        {
          title: 'Form fields have a visible label, not just a tooltip',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Fields have a real label, not just placeholder text',
          wcag: ['3.3.2'],
          level: 'A',
        },
        {
          title: 'Groups of fields have a legend',
          wcag: ['1.3.1', '3.3.2'],
          level: 'A',
        },
        {
          title: 'Groups of options have a group label',
          wcag: ['1.3.1', '3.3.2'],
          level: 'A',
        },
        {
          title: 'Labels are connected to their fields',
          wcag: ['1.3.1', '3.3.2'],
          level: 'A',
        },
        {
          title: 'Field hints are connected to their fields',
          wcag: ['1.3.1', '3.3.2'],
          level: 'A',
        },
        {
          title: 'No two fields share the same label',
          wcag: ['2.4.6'],
          level: 'AA',
        },
        {
          title: 'Error summaries mark which fields are wrong',
          wcag: ['3.3.1'],
          level: 'A',
        },
        {
          title: "Fields with errors aren't marked by colour alone",
          wcag: ['1.4.1', '3.3.1'],
          level: 'A',
        },
        {
          title: 'Error messages say which field is wrong (after submitting)',
          wcag: ['3.3.1'],
          level: 'A',
        },
        {
          title: 'Form error announcements, monitored during interaction',
          wcag: ['4.1.3'],
          level: 'AA',
        },
        {
          title: 'Personal-details fields declare their purpose (autocomplete)',
          wcag: ['1.3.5'],
          level: 'AA',
        },
        {
          title: "Forms don't ask for the same address twice",
          wcag: ['3.3.7'],
          level: 'AA',
        },
        {
          title: 'Password fields allow pasting (password managers)',
          wcag: ['3.3.8'],
          level: 'AA',
        },
      ],
    },
    {
      id: 'structure',
      name: 'Structure & navigation',
      description:
        'Checks headings, lists, tables, landmarks and reading order so assistive tech can navigate the page.',
      method: 'automated',
      checks: [
        {
          title: 'There is a way to skip repeated blocks',
          wcag: ['2.4.1'],
          level: 'A',
        },
        {
          title: 'Skip links point to a real target',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Page has a title',
          wcag: ['2.4.2'],
          level: 'A',
        },
        {
          title: 'Definition lists are built correctly',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: 'Definition terms sit inside a definition list',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: 'Lists contain only list items',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: 'List items sit inside a list',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: "Heading levels don't skip",
          wcag: [],
          level: 'best-practice',
        },
        {
          title: "Headings aren't empty",
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Page has a top-level heading',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Header landmark is top-level',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Footer landmark is top-level',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Main landmark is top-level',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Only one header landmark',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Only one footer landmark',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Only one main landmark',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Page has a main landmark',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Landmarks are distinguishable',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Table cell header references are valid',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: 'Table headers label data cells',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: "Table headers aren't empty",
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Table scope attributes are valid',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Table caption and summary differ',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'There is a way to skip past repeated navigation',
          wcag: ['2.4.1'],
          level: 'A',
        },
        {
          title: 'Text that looks like a heading is marked up as one',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: "Headings aren't whole paragraphs",
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: 'Text that looks like a list is marked up as one',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: "Meaningful text isn't injected by CSS",
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: 'Data tables have header cells',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: 'Column headers have cells under them',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: 'No tables nested inside tables',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: 'Table rows have consistent columns',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: 'Tables with row and column headers say which is which',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: "Tables aren't used for layout",
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: 'Layout tables read in a sensible order',
          wcag: ['1.3.2'],
          level: 'A',
        },
        {
          title: 'Screen-reader order matches the visual order',
          wcag: ['1.3.2'],
          level: 'A',
        },
        {
          title: "Content isn't shown in a different order than it reads",
          wcag: ['1.3.2'],
          level: 'A',
        },
      ],
    },
    {
      id: 'reflow',
      name: 'Reflow, zoom & text spacing',
      description:
        'Resizes the page to a phone width, enlarges text and widens spacing to find content that breaks or gets cut off.',
      method: 'interactive',
      checks: [
        {
          title: "Page doesn't block zoom",
          wcag: ['1.4.4'],
          level: 'AA',
        },
        {
          title: 'Page allows zooming up to 500%',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: "Inline styles don't lock text spacing",
          wcag: ['1.4.12'],
          level: 'AA',
        },
        {
          title: "Page isn't locked to portrait or landscape",
          wcag: ['1.3.4'],
          level: 'AA',
        },
        {
          title: 'Content fits a 320px-wide screen without sideways scrolling',
          wcag: ['1.4.10'],
          level: 'AA',
        },
        {
          title: "Text isn't cut off when enlarged to 200%",
          wcag: ['1.4.4'],
          level: 'AA',
        },
        {
          title:
            "Text isn't cut off when line, letter and word spacing increase",
          wcag: ['1.4.12'],
          level: 'AA',
        },
        {
          title: "Page doesn't stop people from zooming",
          wcag: ['1.4.4'],
          level: 'AA',
        },
      ],
    },
    {
      id: 'motion',
      name: 'Motion & timing',
      description:
        'Watches the page for moving, blinking or timed content that users cannot pause or keep up with.',
      method: 'interactive',
      checks: [
        {
          title: 'No blinking text',
          wcag: ['2.2.2'],
          level: 'A',
        },
        {
          title: 'No scrolling marquee text',
          wcag: ['2.2.2'],
          level: 'A',
        },
        {
          title: "Page doesn't refresh or redirect on a timer",
          wcag: ['2.2.1'],
          level: 'A',
        },
        {
          title: 'Moving or auto-updating content can be paused',
          wcag: ['2.2.2'],
          level: 'A',
        },
        {
          title: 'Animated images stop or can be paused',
          wcag: ['2.2.2'],
          level: 'A',
        },
        {
          title: 'Messages stay long enough to be read',
          wcag: ['2.2.1'],
          level: 'A',
        },
      ],
    },
    {
      id: 'dynamic',
      name: 'Dynamic content & interactions',
      description:
        'Opens menus, dialogs and widgets and changes fields to check that what appears is reachable, announced and dismissible.',
      method: 'interactive',
      checks: [
        {
          title: 'Pop-ups are identified as dialogs',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Dialogs have a name',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Focus moves into a dialog when it opens',
          wcag: ['2.4.3'],
          level: 'A',
        },
        {
          title: 'Focus stays inside an open dialog',
          wcag: ['2.4.3'],
          level: 'A',
        },
        {
          title: 'Dialogs can be closed with the keyboard',
          wcag: ['2.1.2'],
          level: 'A',
        },
        {
          title: 'Focus returns to the trigger when a dialog closes',
          wcag: ['2.4.3'],
          level: 'A',
        },
        {
          title: 'Toggles announce open/closed',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Links that open things are exposed as buttons',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: "Opened menus don't cover what has focus",
          wcag: ['2.4.11', '1.4.13'],
          level: 'AA',
        },
        {
          title: 'Hover/focus pop-ups can be dismissed with Escape',
          wcag: ['1.4.13'],
          level: 'AA',
        },
        {
          title: "Changing a field doesn't change the page by itself",
          wcag: ['3.2.2'],
          level: 'A',
        },
        {
          title: 'Content-change announcements, monitored during interaction',
          wcag: ['4.1.3'],
          level: 'AA',
        },
        {
          title: 'Status-message announcements, monitored during interaction',
          wcag: ['4.1.3'],
          level: 'AA',
        },
      ],
    },
    {
      id: 'language',
      name: 'Language & readability',
      description:
        'Checks that the page and any passages in other languages are declared so they are pronounced correctly.',
      method: 'automated',
      checks: [
        {
          title: 'Page declares its language',
          wcag: ['3.1.1'],
          level: 'A',
        },
        {
          title: 'Page language code is valid',
          wcag: ['3.1.1'],
          level: 'A',
        },
        {
          title: 'lang and xml:lang agree',
          wcag: ['3.1.1'],
          level: 'A',
        },
        {
          title: 'Language changes use valid codes',
          wcag: ['3.1.2'],
          level: 'AA',
        },
        {
          title: 'Passages in another language are marked',
          wcag: ['3.1.2'],
          level: 'AA',
        },
      ],
    },
    {
      id: 'ai',
      name: 'Does the content make sense?',
      description:
        'Flags alt text, link text, headings, labels, titles and instructions that may not make sense — candidates a specialist then reads and confirms.',
      method: 'ai-assisted',
      checks: [
        {
          title: 'Image alt text is adequate for what the image shows',
          wcag: ['1.1.1'],
          level: 'A',
        },
        {
          title: "Information isn't shown as an image of text",
          wcag: ['1.4.5'],
          level: 'AA',
        },
        {
          title: 'Link text says where it goes (in context)',
          wcag: ['2.4.4'],
          level: 'A',
        },
        {
          title: 'Headings describe their section',
          wcag: ['2.4.6'],
          level: 'AA',
        },
        {
          title: 'Labels say what to enter',
          wcag: ['2.4.6'],
          level: 'AA',
        },
        {
          title: 'Text acting as a heading is marked up as one',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: 'Article elements are used for real articles',
          wcag: ['1.3.1'],
          level: 'A',
        },
        {
          title: "Instructions don't rely on position, shape or colour alone",
          wcag: ['1.3.3'],
          level: 'A',
        },
        {
          title: 'Page title describes the page',
          wcag: ['2.4.2'],
          level: 'A',
        },
        {
          title: 'Frame titles describe their content',
          wcag: ['4.1.2'],
          level: 'A',
        },
        {
          title: 'Page language is set correctly',
          wcag: ['3.1.1'],
          level: 'A',
        },
        {
          title: 'Text in another language is marked',
          wcag: ['3.1.2'],
          level: 'AA',
        },
        {
          title: "Login doesn't depend on a text CAPTCHA",
          wcag: ['3.3.8'],
          level: 'AA',
        },
        {
          title: 'Form errors say how to fix the problem',
          wcag: ['3.3.3'],
          level: 'AA',
        },
        {
          title: 'Link text makes sense on its own (AAA)',
          wcag: ['2.4.9'],
          level: 'AAA',
        },
        {
          title: 'Text is written at an accessible reading level (AAA)',
          wcag: ['3.1.5'],
          level: 'AAA',
        },
      ],
    },
    {
      id: 'aaa',
      name: 'Enhanced (AAA) suggestions',
      description:
        'Optional suggestions toward WCAG AAA — reported separately and never counted against your score.',
      method: 'automated',
      checks: [
        {
          title: 'Text contrast reaches 7:1 (AAA)',
          wcag: ['1.4.6'],
          level: 'AAA',
        },
        {
          title: 'Line spacing is at least 1.5 (AAA)',
          wcag: ['1.4.8'],
          level: 'AAA',
        },
        {
          title: 'Lines are under 80 characters (AAA)',
          wcag: ['1.4.8'],
          level: 'AAA',
        },
        {
          title: "Text isn't fully justified (AAA)",
          wcag: ['1.4.8'],
          level: 'AAA',
        },
        {
          title: "Links don't open new windows unannounced (AAA)",
          wcag: ['3.2.5'],
          level: 'AAA',
        },
        {
          title: 'Abbreviations are expanded (AAA)',
          wcag: ['3.1.4'],
          level: 'AAA',
        },
        {
          title: 'Long text is broken up with section headings (AAA)',
          wcag: ['2.4.10'],
          level: 'AAA',
        },
        {
          title: 'Page never refreshes or redirects by itself (AAA)',
          wcag: ['2.2.4', '3.2.5'],
          level: 'AAA',
        },
      ],
    },
    {
      id: 'bp',
      name: 'Best-practice suggestions',
      description:
        'Non-WCAG hygiene that still makes pages harder to use or maintain — suggestions only, never scored.',
      method: 'automated',
      checks: [
        {
          title: 'No long passages in capital letters',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'No long passages in italics',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'No very small text',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Right-to-left text is shown right to left',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Data tables have a caption',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Data tables have no empty cells',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Image alt and title agree',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Adjacent links are separated by text or punctuation',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Link titles add something beyond the link text',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Document links state format and size',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Labels sit close to their fields',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: "Tab doesn't stop on things that do nothing",
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'No access keys',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'No duplicate ids',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'No empty paragraphs used for spacing',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'No deprecated HTML elements',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'No spacer images',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: "Colours aren't set with inline styles",
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Preformatted code uses <code>',
          wcag: [],
          level: 'best-practice',
        },
        {
          title: 'Page has a skip link',
          wcag: [],
          level: 'best-practice',
        },
      ],
    },
  ],
};
